import React from 'react'
import MotionHoc from '../../../../utils/MotionHoc';

function MainHistory() {
    return (
        <div>MainHistory</div>
    )
}

// export default MainHistory
const MainHistorys = MotionHoc(MainHistory);
export default MainHistorys;